var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cstm-status-badge",staticStyle:{"background":"rgba(var(--vs-primary), 1)","color":"#fff"}},[_c('b',[_vm._v(_vm._s(_vm.params.data.final_marks ? _vm.params.data.final_marks : 'N/A'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }